import axios from 'axios'
import router from '@/router'
const api = `https://members.eccourts.org/`
const endPoint = `wp-json/wp/v2/`

export const 	getCookie = (cname) =>{
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
	}
	export const getProfile = () => {
		let url = `${api}${endPoint}/me?context=edit`
		let token = getCookie('wcmCookie')
		axios.get( url, {
			headers:{
				Authorization: 'Bearer'+token
			}
		})
	}
export default {
    generateToken(user, password){
		let vm = this;
		return new Promise(function(resolve, reject) {
			axios.post('https://members.eccourts.org/wp-json/jwt-auth/v1/token', {
				username: user,
				password: password
			})
			.then(function (response) {
				// eslint-disable-next-line
				console.log(response)
				window.localStorage.setItem('authUser', JSON.stringify(response.data))
				vm.setCookie("wcmCookie",response.data.token,1);
				resolve(response.data);
			
			})
			.catch(function (error) {
                // eslint-disable-next-line 
           
				reject(Error(`${error}`));
			});
		});
	},
	validate(){
		let vm = this;
        let token = this.getCookie("wcmCookie");
        return new Promise(function(resolve, reject) {
            axios.post('https://members.eccourts.org/wp-json/jwt-auth/v1/token/validate', {}, {
                headers: { "Authorization": 'Bearer' + token }
            })
            // eslint-disable-next-line
            .then(function (response) {
                vm.isTokenValid = true;
                resolve(vm.isTokenValid );
               // return true;
            })
            // eslint-disable-next-line
            .catch(function (error) {
                reject(Error('Cannot generate token!'));
            });
        })
  },
  getUserInfo(/* email */){
		let vm = this
    let token = this.getCookie("wcmCookie");
    let url = `${api}${endPoint}`
    return new Promise((resolve, reject)=>{
      axios.get(`${url}users/me?context=edit`,{
        headers: { "Authorization": 'Bearer' + token }
      })
      .then(data=>{
        resolve(data)
      })
      .catch(err=>{
				vm.logout()
        reject(err)
      })
    })
  },
	setCookie(cname, cvalue, exdays) {
		let d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		let expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	},
	logout(){
		document.cookie = "wcmCookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		window.localStorage.removeItem('user')
		window.localStorage.removeItem('userProfile')
		window.localStorage.removeItem('user')
		router.replace('/login')
		
	},
	getCookie,

}